export default __webpack_public_path__ + "static/DataInsight-67f4876c5eac0b8236135bdd104276ef.svg";